import { useTranslation } from 'react-i18next';
import { Wallet } from 'lucide-react';

/**
 * Payment-method prompt (W8/R13) — shown on the Advance COD tab when the
 * summary reports `payment_method_missing`. The merchant is enrolled but has no
 * stored payout channel, so FFC can't disburse until one is added. Amber
 * design-language warning banner, consistent with the low-balance alert.
 */
function AdvancePaymentMethodBanner() {
  const { t } = useTranslation();
  return (
    <div
      className='mb-4 flex items-start gap-3 rounded-2xl border border-solid border-[#F1DFAF] bg-[#FCF3DD] px-[18px] py-4'
      data-testid='advance-cod-payment-method-banner'
    >
      <span className='inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-[#F6E6BE]'>
        <Wallet className='h-[18px] w-[18px] text-[#B7791F]' strokeWidth={2} />
      </span>
      <div>
        <div className='text-[14px] font-bold text-[#8A5A12]'>
          {String(t('advance_cod_payment_method_missing_title'))}
        </div>
        <div className='mt-0.5 text-[13px] leading-[1.5] text-[#8A6A2E]'>
          {String(t('advance_cod_payment_method_missing_body'))}
        </div>
      </div>
    </div>
  );
}

export default AdvancePaymentMethodBanner;
